<template>
    <ul>
        <slot/>
    </ul>
</template>

<script>
export default {
    name: 'BaseAccordian',
    props: {
        initialActiveIndex: {
            type: Number,
        },
    },
    data() {
        return {
            panels: [],
            activePanel: undefined,
        };
    },
    methods: {
        navigate(panel) {
            this.activePanel = panel;
        },
    },
    created() {
        this.$on('add-panel', panel => this.panels.push(panel));
        this.$on('set-active-panel', (panel) => {
            this.activePanel = panel;
        });
    },
    mounted() {
        this.activePanel = this.initialActiveIndex === null
            ? null : this.panels[this.initialActiveIndex];
    },
};
</script>



// WEBPACK FOOTER //
// BaseAccordian.vue?daa853f6